import React, { FC } from 'react';
import cls from './ModeTabs.module.css';
import classNames from 'classnames';
import { useModeTabs } from './useModeTabs';
import { useSelector } from 'react-redux';

export const ModeTabs = () => {
    const { activeTab, changeTab } = useModeTabs();

    return (
        <div className={classNames(cls.ModeTabs)} data-active-tab={activeTab}>
            <div
                onClick={() => changeTab('day')}
                className={classNames(cls.day, { [cls.active]: activeTab === 'day' })}
            >
                {i18next.t('ModeTabs.return.ModeTabs.day')}
            </div>
            <div
                onClick={() => changeTab('week')}
                className={classNames(cls.week, { [cls.active]: activeTab === 'week' })}
            >
                {i18next.t('ModeTabs.return.ModeTabs.week')}
            </div>
            <div
                onClick={() => changeTab('month')}
                className={classNames(cls.month, { [cls.active]: activeTab === 'month' })}
            >
                {i18next.t('ModeTabs.return.ModeTabs.month')}
            </div>
        </div>
    );
};
